"use client"
import {
  Autocomplete,
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  MenuItem,
  Paper,
  Radio,
  TextField,
} from "@mui/material"
import { styled } from "@mui/material/styles"
import { DatePicker } from "@mui/x-date-pickers/DatePicker"
import React from "react"
import { NumericFormat } from "react-number-format"
import { Colors } from "../Theme/colors"
import { Fonts } from "../Theme/font"
import { currencyDisplayConfig } from "@/lib/util"

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
export const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 312,
      padding: "16px 4px 16px 12px",
      alignItems: "flex-start",
      gap: 8,
      borderRadius: 8,
      border: `1px solid ${Colors.secondaryLight}`,
      boxShadow: "none",
    },
  },
}

export const PagesizeMenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 112,
      padding: "16px 8px 16px 8px",
      alignItems: "flex-start",
      gap: 8,
      borderRadius: 8,
      border: `1px solid ${Colors.secondaryLight}`,
      boxShadow: "none",
    },
  },
}
export const FormTitle = styled(Box)({
  width: "100%",
  font: `normal 700 24px/24px ${Fonts.secondary} `,
  color: Colors.dark,
  textAlign: "center",
  textTransform: "capitalize",
})
export const StyledMenuItem = styled(MenuItem)({
  font: `normal normal 400 normal 16px/24px ${Fonts.primary}`,
  color: Colors.dark,
  padding: "8px 16px",
  boxShadow: "none",
  "&:hover": {
    background: Colors.offwhite,
  },
  "&:focused": {
    background: Colors.offwhite,
    font: `normal normal 600 normal 16px/24px ${Fonts.primary}`,
  },
})
export const StyledAutoCompltePaper = styled(Paper)({
  font: `normal normal 400 normal 16px/24px ${Fonts.primary}`,
  padding: 8,
  boxShadow: "none",
  backgroundColor: Colors.light,

  // border: `1px solid #E9E9E9`,
})
export const IconStyle = styled("span")(() => ({
  borderRadius: 2,
  width: 18,
  height: 18,
  boxShadow: "none",
  color: "#B3B3B3",
  ".Mui-focusVisible &": {
    outline: "none",
    outlineOffset: 0,
  },
  "input:hover ~ &": {
    backgroundColor: "#fff",
  },
}))

export const StyledSearchField = styled(TextField)({
  "& .MuiOutlinedInput-root": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 8,
    background: "#FFF 0% 0% no-repeat padding-box",
    color: Colors.textColor,
    width: "100%",
    height: 48,
    font: `normal normal 400 normal 16px/24px ${Fonts.primary}`,
    "& fieldset": {
      borderColor: Colors.borderColor,
      borderWidth: 1,
    },
    "&:hover fieldset": {
      borderColor: Colors.primary,
      borderWidth: 1,
    },
    "&.Mui-focused fieldset": {
      borderColor: Colors.primary,
      borderWidth: 1,
    },
  },
  "& .MuiOutlinedInput-input": {
    "&:-webkit-autofill": {
      WebkitBoxShadow: `0 0 0 100px ${Colors.greyLightest} inset`,
      backgroundColor: "transparent",
      padding: "12px 13px",
    },
  },
})
export const StyledTextField = styled(TextField)({
  "& label": {
    font: `normal normal 400 normal 16px/30px ${Fonts.primary}`,
    textTransform: "capitalize",
  },
  "& label.Mui-focused": {
    color: Colors.primary,
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: Colors.primary,
  },

  "& .MuiOutlinedInput-root": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 8,
    background: "#FFF",
    color: Colors.textColor,
    height: 48,
    width: "100%",
    gap: 8,
    font: `normal normal 400 normal 16px/24px ${Fonts.primary}`,
    "& fieldset": {
      borderColor: Colors.borderColor,
      borderWidth: 1,
    },
    "&:hover fieldset": {
      borderColor: Colors.primary,
      borderWidth: 1,
    },
    "&.Mui-focused fieldset": {
      borderColor: Colors.primary,
      borderWidth: 1,
    },
  },
  "& input:valid": {
    borderColor: Colors.buttonSuccess,
    borderWidth: 1,
  },
  "& input:invalid": {
    borderColor: Colors.buttonError,
    borderWidth: 1,
  },
  "& .MuiOutlinedInput-input": {
    "&:-webkit-autofill": {
      WebkitBoxShadow: `0 0 0 100px ${Colors.greyLightest} inset`,
      backgroundColor: "transparent",
      padding: "12px 13px",
    },
  },
})
export const StyledAutoComplete = styled(Autocomplete)({
  "&.MuiAutocomplete-paper": {
    backgroundColor: Colors.buttonError,
  },
})
export const StyledAutoCompleteField = styled(TextField)({
  "& label": {
    font: `normal normal 400 normal 16px/30px ${Fonts.primary}`,
    textTransform: "capitalize",
  },
  "& label.Mui-focused": {
    color: Colors.primary,
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: Colors.primary,
  },

  "& .MuiOutlinedInput-root": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 8,
    background: "#FFF 0% 0% no-repeat padding-box",
    color: Colors.textColor,
    width: "100%",
    gap: 8,
    minHeight: 48,
    font: `normal normal 400 normal 16px/24px ${Fonts.primary}`,
    "& fieldset": {
      borderColor: Colors.borderColor,
      borderWidth: 1,
    },
    "&:hover fieldset": {
      borderColor: Colors.primary,
      borderWidth: 1,
    },
    "&.Mui-focused fieldset": {
      borderColor: Colors.primary,
      borderWidth: 1,
    },
  },
  "& input:valid": {
    borderColor: Colors.buttonSuccess,
    borderWidth: 1,
  },
  "& input:invalid": {
    borderColor: Colors.buttonError,
    borderWidth: 1,
  },
  "& .MuiOutlinedInput-input": {
    "&:-webkit-autofill": {
      WebkitBoxShadow: `0 0 0 100px ${Colors.greyLightest} inset`,
      backgroundColor: "transparent",
      padding: "12px 13px",
    },
  },
})
export const StyledSelectFormControl = styled(FormControl)({
  "& label": {
    font: `normal normal 400 normal 16px/30px ${Fonts.primary}`,
    textTransform: "capitalize",
  },
  "& label.Mui-focused": {
    color: Colors.primary,
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: Colors.primary,
  },

  "& .MuiOutlinedInput-root": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 8,
    background: "#FFF 0% 0% no-repeat padding-box",
    color: Colors.textColor,
    height: 48,
    width: "100%",
    gap: 8,
    font: `normal normal 400 normal 16px/24px ${Fonts.primary}`,
    "& fieldset": {
      borderColor: Colors.borderColor,
      borderWidth: 1,
    },
    "&:hover fieldset": {
      borderColor: Colors.primary,
      borderWidth: 1,
    },
    "&.Mui-focused fieldset": {
      borderColor: Colors.primary,
      borderWidth: 1,
    },
  },
  "& input:valid": {
    borderColor: Colors.buttonSuccess,
    borderWidth: 1,
  },
  "& input:invalid": {
    borderColor: Colors.buttonError,
    borderWidth: 1,
  },
  "& .MuiOutlinedInput-input": {
    "&:-webkit-autofill": {
      WebkitBoxShadow: `0 0 0 100px ${Colors.greyLightest} inset`,
      backgroundColor: "transparent",
      padding: "12px 13px",
    },
  },
})

export const PagesizeSelectFormControl = styled(FormControl)({
  "& label": {
    font: `normal normal 400 normal 16px/30px ${Fonts.primary}`,
    textTransform: "capitalize",
  },
  "& label.Mui-focused": {
    color: Colors.primary,
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: Colors.primary,
  },

  "& .MuiOutlinedInput-root": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 8,
    background: "#FFF 0% 0% no-repeat padding-box",
    color: Colors.textColor,
    paddingRight: 0,
    paddingTop: 3,
    gap: 0,
    font: `normal normal 400 normal 16px/24px ${Fonts.primary}`,
    "& fieldset": {
      borderColor: Colors.light,
      borderWidth: 1,
    },
    "&:hover fieldset": {
      borderColor: Colors.light,
      borderWidth: 1,
    },
    "&.Mui-focused fieldset": {
      borderColor: Colors.light,
      borderWidth: 1,
    },
  },
  "& input:valid": {
    borderColor: Colors.buttonSuccess,
    borderWidth: 1,
  },
  "& input:invalid": {
    borderColor: Colors.buttonError,
    borderWidth: 1,
  },
  "& .MuiOutlinedInput-input": {
    "&:-webkit-autofill": {
      WebkitBoxShadow: `0 0 0 100px ${Colors.greyLightest} inset`,
      backgroundColor: "transparent",
      padding: "12px 13px",
    },
  },
})
export const StyledTextArea = styled(TextField)({
  "& label": {
    font: `normal normal 400 normal 16px/24px ${Fonts.primary}`,
    textTransform: "capitalize",
  },
  "& label.Mui-focused": {
    color: Colors.primary,
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: Colors.primary,
  },

  "& .MuiOutlinedInput-root": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 8,
    background: "#FFF 0% 0% no-repeat padding-box",
    color: Colors.textColor,
    width: "100%",
    minHeight: 80,
    font: `normal normal 400 normal 16px/24px ${Fonts.primary}`,
    gap: 8,
    "& fieldset": {
      borderColor: Colors.borderColor,
      borderWidth: 1,
    },
    "&:hover fieldset": {
      borderColor: Colors.primary,
      borderWidth: 1,
    },
    "&.Mui-focused fieldset": {
      borderColor: Colors.primary,
      borderWidth: 1,
    },
  },
  "& input:valid": {
    borderColor: Colors.buttonSuccess,
    borderWidth: 1,
  },
  "& input:invalid": {
    borderColor: Colors.buttonError,
    borderWidth: 1,
  },
  "& input:valid:focus + fieldset": {
    padding: "4px !important", // override inline-style
  },
  "& .MuiOutlinedInput-input": {
    "&:-webkit-autofill": {
      WebkitBoxShadow: `0 0 0 100px ${Colors.greyLightest} inset`,
      backgroundColor: "transparent",
      padding: "12px 13px",
    },
  },
})
export const StyledDatePicker = styled(DatePicker)({
  "& label": {
    font: `normal normal  400 normal 16px/30px ${Fonts.primary}`,
    textTransform: "capitalize",
  },
  "& label.Mui-focused": {
    color: Colors.primary,
  },
  // "&.MuiFormControl-root": { width: "100%" },
  "& .MuiInput-underline:after": {
    borderBottomColor: Colors.primary,
  },
  "& .MuiInputBase-root": {
    width: "100%",
  },
  "& .MuiOutlinedInput-root": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 8,
    background: "#FFF",
    color: Colors.textColor,
    width: "100%",
    height: 48,
    font: `normal normal 400 normal 16px/24px ${Fonts.primary}`,
    gap: 8,
    "& fieldset": {
      borderColor: Colors.borderColor,
      borderWidth: 1,
    },
    "&:hover fieldset": {
      borderColor: Colors.primary,
      borderWidth: 1,
    },
    "&.Mui-focused fieldset": {
      borderColor: Colors.primary,
      borderWidth: 1,
    },
  },
  "& .Mui-error": {
    color: Colors.deletePrimary,
    borderColor: Colors.deletePrimary,
  },
  "& input:valid + fieldset": {
    borderColor: Colors.primary,
    borderWidth: 1,
  },
  "& input:invalid + fieldset": {
    borderColor: Colors.deletePrimary,
    borderWidth: 1,
  },
  "& input:valid:focus + fieldset": {
    borderLeftWidth: 4,
    padding: "4px !important", // override inline-style
  },
  "& .MuiFormHelperText-root": {
    font: `normal normal 400 normal 12px/24px ${Fonts.tertiary}`,
    color: Colors.deletePrimary,
  },
  "& .MuiOutlinedInput-input": {
    "&:-webkit-autofill": {
      WebkitBoxShadow: `0 0 0 100px rgba(255, 255, 255, 0.20) inset`,
      backgroundColor: "transparent",
      padding: "12px 13px",
    },
  },

  "& .MuiSvgIcon-root": {
    fill: `${Colors.greyLight}`,
    fontSize: 22,
  },
})
export const StyledBorderDatePicker = styled(DatePicker)({
  "& label": {
    font: `normal normal 400 normal 16px/24px ${Fonts.primary}`,
    textTransform: "capitalize",
  },
  "& label.Mui-focused": {
    color: Colors.primary,
  },
  "&.MuiFormControl-root": { width: "100%" },
  "& .MuiInput-underline:after": {
    borderBottomColor: Colors.primary,
  },
  "& .MuiInputBase-root": {
    width: "100%",
  },
  "& .MuiOutlinedInput-root": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 8,
    background: "#FFF 0% 0% no-repeat padding-box",
    color: Colors.textColor,
    width: "100%",
    height: 48,
    font: `normal normal 400 normal 16px/24px ${Fonts.primary}`,
    gap: 8,
    "& fieldset": {
      border: "none",
      borderBottomColor: Colors.borderColor,
      borderBottomWidth: 1,
    },
    "&:hover fieldset": {
      border: "none",
      borderBottomColor: Colors.borderColor,
      borderBottomWidth: 1,
    },
    "&.Mui-focused fieldset": {
      border: "none",
      borderBottomColor: Colors.borderColor,
      borderBottomWidth: 1,
    },
  },
  "& .MuiSvgIcon-root": {
    fill: `${Colors.greyLight}`,
    fontSize: 22,
  },
})

export const BpIcon = styled("span")({
  borderRadius: 3,
  width: 22,
  height: 22,
  backgroundColor: Colors.light,
  border: `1px solid ${Colors.primaryDarkest}`,
  borderRadius: 8,
  ".Mui-focusVisible &": {
    outline: `2px auto ${Colors.primaryDarkest}`,
    outlineOffset: 2,
  },
  "input:hover ~ &": {
    backgroundColor: Colors.light,
  },
  "input:disabled ~ &": {
    boxShadow: "none",
    background: Colors.disabled,
  },
})

export const BpCheckedIcon = styled(BpIcon)({
  backgroundColor: Colors.primaryDarkest,
  "&:before": {
    display: "block",
    width: 20,
    height: 20,
    backgroundImage:
      "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
      " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
      "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
    content: '""',
  },
  "input:hover ~ &": {
    backgroundColor: Colors.primaryDarkest,
  },
})
export const StyledFormControlLabel = styled(FormControlLabel)({
  "& .MuiFormControlLabel-label": {
    font: `normal 500 16px/16px ${Fonts.primary}`,
    color: Colors.dark,
  },
})
export const BpRadioIcon = styled("span")(() => ({
  borderRadius: "50%",
  width: 22,
  height: 22,
  border: `1px solid ${Colors.primaryDarkest}`,
  backgroundColor: Colors.light,
  ".Mui-focusVisible &": {
    outline: "2px auto rgba(19,120,189,.6)",
    outlineOffset: 2,
  },
  "input:hover ~ &": {
    backgroundColor: "#ebf1f5",
  },
  "input:disabled ~ &": {
    boxShadow: "none",
    background: Colors.disabled,
  },
}))
export const BpRadioCheckedIcon = styled(BpRadioIcon)({
  backgroundColor: Colors.primaryDarkest,
  "&:before": {
    display: "block",
    width: 20,
    height: 20,
    backgroundImage: "radial-gradient(#fff,#fff 28%,transparent 32%)",
    content: '""',
  },
  "input:hover ~ &": {
    backgroundColor: Colors.light,
  },
})

export const NumericFormatCustom = React.forwardRef(
  function NumericFormatCustom(props, ref) {
    const { onChange, currency, name, ...other } = props
    const config = currencyDisplayConfig[currency] || {
      symbol: "₦",
      position: "prefix",
    }

    return (
      <NumericFormat
        {...other}
        getInputRef={ref}
        onValueChange={(values) => {
          onChange({
            target: {
              name,
              value: values.value,
            },
          })
        }}
        decimalScale={2}
        thousandSeparator
        valueIsNumericString
        fixedDecimalScale
        prefix={config.position === "prefix" ? config.symbol : undefined}
        suffix={config.position === "suffix" ? ` ${config.symbol}` : undefined}
      />
    )
  }
)

// STYLED RADIO BUTTON
export function StyleRadioButton({ name, label, control, value, ...rest }) {
  return (
    <StyledFormControlLabel
      control={
        <Radio
          sx={{
            "&:hover": {
              bgcolor: "transparent",
            },
          }}
          disableRipple
          name={name}
          value={value}
          checkedIcon={<BpRadioCheckedIcon />}
          icon={<BpRadioIcon />}
          color="default"
          inputRef={control}
          {...rest}
        />
      }
      label={label}
    />
  )
}

export function StyledCheckbox({ label, control, name, ...rest }) {
  return (
    <StyledFormControlLabel
      control={
        <Checkbox
          sx={{
            "&:hover": {
              bgcolor: "transparent",
            },
          }}
          disableRipple
          color="default"
          checkedIcon={<BpCheckedIcon />}
          icon={<BpIcon />}
          {...rest}
        />
      }
      label={label}
      name={name}
      inputRef={control}
    />
  )
}
